<template>
  <el-dialog
    :title="$t('132')"
    :close-on-click-modal="false"
    append-to-body
    :visible.sync="visible"
    width="800px"
    class="message-add"
    @closed="$emit('closed')"
  >
    <el-form ref="dataForm" :model="form" :rules="dataRule" class="message-add-ueditor">
      <el-form-item prop="type">
        <el-radio-group v-model="form.type">
          <el-radio-button v-for="(item, index) in btnConfig" :key="index" :label="item.label">
            {{ item.name }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('864')" v-if="form.type === '2'" prop="ids">
        <department multiple :change="departmentHandle"></department>
      </el-form-item>
      <el-form-item :label="$t('865')" v-if="form.type === '3'" prop="ids">
        <el-input type="textarea" :rows="2" :placeholder="$t('865')" v-model="form.ids"> </el-input>
      </el-form-item>
      <el-form-item :label="$t('204')" prop="name">
        <el-input v-model="form.name" :placeholder="$t('867')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('866')" prop="content">
        <ueditor
          :id="'message-add-ueditor-' + Date.now()"
          :key="'message-add-ueditor'"
          v-model="form.content"
          :action-url="'/app/tool/upload_url'"
          :height="400"
        />
      </el-form-item>
      <el-form-item :label="$t('868')">
        <el-radio-group v-model="form.is_top">
          <el-radio v-for="(item, index) in topConfig" :key="index" :label="item.label">
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('1693')">
        <el-radio-group v-model="form.must_read">
          <el-radio v-for="item in mustReadConfig" :key="item.label" :label="item.label">
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <select-dep-tree ref="selectDepTree" v-if="isSelectDepTree"></select-dep-tree>
    <span slot="footer">
      <el-button type="primary" plain @click="submit" :disabled="disabled">
        {{ $t('288') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addFn } from 'api/tool/message'
import ueditor from '@/components/ueditor'
import { topConfig, btnConfig, mustReadConfig } from './config'
import selectDepTree from './select-dep-tree'
import department from '@/components/department'

export default {
  props: ['category'],
  components: {
    ueditor,
    selectDepTree,
    department
  },
  data() {
    return {
      visible: false,
      topConfig: topConfig(this),
      btnConfig: btnConfig(this),
      mustReadConfig: mustReadConfig(this),
      form: {
        name: '',
        content: '',
        type: '1',
        ids: null,
        is_top: '0', // 默认不置顶
        must_read: '0' // 打开时 是否必读
      },
      dataRule: {
        name: [
          {
            required: true,
            message: this.$t('867')
          }
        ],
        content: [
          {
            required: true,
            message: this.$t('867')
          }
        ],
        ids: [
          {
            required: true,
            message: this.$t('221')
          }
        ]
      },
      disabled: false,
      isSelectDepTree: false
    }
  },
  methods: {
    init() {
      this.visible = true
      this.$nextTick(() => this.$refs.dataForm.clearValidate())
    },
    showDeepTree() {
      this.isSelectDepTree = true
      this.$nextTick(() => this.$refs.selectDepTree.init())
    },
    departmentHandle(val1, val2) {
      this.form.ids = [...new Set(val2.flat(999999))].join(',')
    },
    submit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.disabled = true
          addFn({
            ...this.form,
            category: this.category
          })
            .then(res => {
              this.disabled = false
              if (res && res.code === 1) {
                this.visible = false
                this.$emit('refreshTableList')
              }
            })
            .finally(() => (this.disabled = false))
        }
      })
    }
  },
  watch: {
    visible(val) {
      if (!val) this.$refs.dataForm.resetFields()
    },
    'form.type'() {
      this.form.ids = null
    }
  }
}
</script>

<style lang="scss" scoped>
.message-add {
  /deep/ .el-dialog {
    max-width: 1200px;
  }
}
</style>

<style lang="scss">
.message-add-ueditor {
  .el-form-item--medium .el-form-item__label {
    width: 100%;
    float: none;
  }
}
</style>
